// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__21Bv9","left":"StickyBox_left__3D82p","right":"StickyBox_right__NN7nx"};